import { AuthenticationFacade } from '../authentication';
import { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';

export interface ComponentCanDeactivate {
  canDeactivate: () => Promise<boolean>;
}

export const PendingChangesGuard: CanDeactivateFn<ComponentCanDeactivate> = async (component) => {
  const auth = inject(AuthenticationFacade);
  const isAuthenticated = await auth.isAuthenticated();
  if (!isAuthenticated) {
    return true;
  }

  return component.canDeactivate();
};
